// Copyright (c) 2026 Query Health Inc. All rights reserved.
// Author: Anmol Rajpal <anmol@quantinohealth.com>
// Licensed under a Commercial License. See LICENSE for terms.

// Shown when Firebase auth is not configured (a deploy/ops misconfiguration). Degrades the
// phone/Google steps to a clear, honest message instead of a white screen or a cryptic SDK
// crash. Gated on isFirebaseConfigured by the auth screens.

import { useTranslation } from 'react-i18next'
import { AlertCircle } from 'lucide-react'
import { OnboardingLayout } from '@/components/OnboardingLayout'

export function AuthUnavailable() {
  const { t } = useTranslation()
  return (
    <OnboardingLayout>
      <div className="flex flex-col flex-1 items-center justify-center px-6 py-16 gap-4 text-center">
        <div className="h-14 w-14 rounded-2xl bg-destructive/10 flex items-center justify-center">
          <AlertCircle className="h-7 w-7 text-destructive" />
        </div>
        <div>
          <h1 className="text-xl font-bold text-foreground">{t('auth.unavailableTitle')}</h1>
          <p className="text-muted-foreground text-sm mt-2 leading-relaxed max-w-xs mx-auto">
            {t('auth.unavailableBody')}
          </p>
        </div>
      </div>
    </OnboardingLayout>
  )
}
